import { createFilter, deleteFilter, getFilters, updateFilter } from "../../api/favFilters";
import _ from "lodash";

const favFilters = {
    namespaced: true,
    state: {
        filters: {},
    },
    mutations: {
        SET_FILTERS: (state, filters) => {
            state.filters = filters;
        },
    },
    actions: {
        getFilters({ state }, key) {
            return state.filters[key] || [];
        },
        createFilter({ state, commit }, { key, name, filters }) {
            return createFilter(key, name, filters).then((res) => {
                let groupedFilters = { ...state.filters };
                groupedFilters[key] = [...(groupedFilters[key] || []), res.data];
                commit("SET_FILTERS", groupedFilters);
                return res.data;
            });
        },
        updateFilter({ state, commit }, { id, key, name, filters }) {
            return updateFilter(id, name, filters).then((res) => {
                let groupedFilters = { ...state.filters };
                groupedFilters[key] = (groupedFilters[key] || []).map((filter) => {
                    if (filter._id === id) filter = res.data;
                    return filter;
                });
                commit("SET_FILTERS", groupedFilters);
                return res.data;
            });
        },
        async fetchFilters({ commit, state }, key) {
            let filters = state.filters[key];
            if (!filters) {
                filters = await getFilters(key).then((response) => {
                    const { data } = response;
                    const filters = _.groupBy(data, (d) => d.key);
                    commit("SET_FILTERS", filters);
                    return filters;
                });
            }
            return filters;
        },
        deleteFilter({ commit, state }, { id, key }) {
            return deleteFilter(id).then(() => {
                let groupedFilters = { ...state.filters };
                groupedFilters[key] = (groupedFilters[key] || []).filter((f) => f._id !== id);
                commit("SET_FILTERS", groupedFilters);
            });
        },
    },
};

export default favFilters;
